import { ObjectType } from '@xbcb/shared-types';

export const assumePermission: { [key: string]: ObjectType } = {
  [ObjectType.SUBJECT_MATTER_EXPERT_TEAM]: ObjectType.ASSIGNMENT_TEAM,
  [ObjectType.WORK_ORDER_TASK_ESCALATION_MESSAGE]: ObjectType.WORK_ORDER_TASK,
};
